import { render, staticRenderFns } from "./EmbroideryShelf.vue?vue&type=template&id=2319daf3&scoped=true"
import script from "./EmbroideryShelf.vue?vue&type=script&lang=js"
export * from "./EmbroideryShelf.vue?vue&type=script&lang=js"
import style0 from "./EmbroideryShelf.vue?vue&type=style&index=0&id=2319daf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2319daf3",
  null
  
)

export default component.exports